import { WORKSPACE_TOOL_NAMES } from "../../turns/turn-constants";

/**
 * The native tool each remote workspace tool shadows. `workspace_task_output`
 * and `workspace_task_stop` have no native counterpart and keep their own name.
 */
export const NATIVE_EQUIVALENT: Record<string, string> = {
  [WORKSPACE_TOOL_NAMES.BASH]: "bash",
  [WORKSPACE_TOOL_NAMES.READ]: "read",
  [WORKSPACE_TOOL_NAMES.WRITE]: "write",
  [WORKSPACE_TOOL_NAMES.EDIT]: "edit",
  [WORKSPACE_TOOL_NAMES.GLOB]: "glob",
  [WORKSPACE_TOOL_NAMES.GREP]: "grep",
};
